import React, { Key, useMemo } from "react";
import classes from "classnames";
import styles from "./index.module.scss";
import { PageStatus } from "../../types";

export interface ChaptersNavigatorProps
  extends React.HTMLAttributes<HTMLDivElement> {
  icon: string;
  name: string;
  completed: number;
  total: number;
  open?: boolean;
}

const ChaptersNavigator = ({
  className,
  icon,
  name,
  completed,
  total,
  children,
  open,
  onClick,
  ...props
}: ChaptersNavigatorProps) => {
  const status = useMemo<PageStatus>(() => {
    if (completed === 0) {
      return "lock";
    }
    if (completed < total) {
      return "undo";
    }
    if (completed === total) {
      return "done";
    }
    return "undo";
  }, [completed, total]);
  return (
    <div
      {...props}
      className={classes(
        styles.pagesNavigator,
        open && styles.open,
        styles[status],
        className
      )}
    >
      <div className={styles.header} onClick={onClick}>
        <div>
          <img src={icon} className={styles.icon} alt="" />
          <div className={styles.name}>{name}</div>
        </div>
        <div>
          <div className={styles.progress}>
            {completed}/{total}
          </div>
          <div className={styles.arrow} />
        </div>
      </div>
      <div className={classes(styles.body, !open && styles.hide)}>
        {children}
      </div>
    </div>
  );
};

export interface PageNavigatorAccordionProps {
  className?: string;
  onChange?: (key: Key) => void;
  activeKey?: Key;
  children:
  | React.ReactElement<ChaptersNavigatorProps>[]
  | React.ReactElement<ChaptersNavigatorProps>;
}

const PagesNavigatorAccordion = ({
  className,
  onChange,
  activeKey,
  children,
}: PageNavigatorAccordionProps) => {
  return (
    <div className={className}>
      {React.Children.map(children, (child, index) => {
        return React.cloneElement(child, {
          ...child.props,
          open: activeKey === child.key,
          onClick: () => onChange?.(child.key || index),
        });
      })}
    </div>
  );
};

ChaptersNavigator.Accordion = PagesNavigatorAccordion;

export default ChaptersNavigator;
